module.exports = __webpack_public_path__ + "static/Frog-73dfa8012b7859ffbbe9df5d5d8e0709.jpg";